import type { RadioGroupProps } from '@ksyos/design-system/dist/components/radio-group';
import { Radio, RadioGroup, TextArea } from '@ksyos/design-system';
import React from 'react';
import { getValidationErrorTranslation } from '@frontend/utils/getValidationErrorTranslation';
import type { IOption } from '../interfaces/option';
import { InputContainer } from '../elements/forms';

interface IRadioGroupWithTextAreaProps extends Omit<RadioGroupProps, 'children'> {
    onChangeTextArea: (value: string) => void;
    radioItems: IOption<string>[];
    textAreaValue: string;
}

export function RadioGroupWithTextArea(props: IRadioGroupWithTextAreaProps) {
    const { textAreaValue, radioItems, onChangeTextArea, ...radioGroupProps } = props;

    return (
        <InputContainer>
            <RadioGroup {...getRadioGroupProps(radioGroupProps)}>
                {renderFields(radioItems, textAreaValue, onChangeTextArea, radioGroupProps.value)}
            </RadioGroup>
        </InputContainer>
    );
}

function renderFields(
    radioItems: IOption<string>[],
    textAreaValue: string,
    onChangeTextArea: (value: string) => void,
    radioValue: string | undefined
) {
    const options: React.JSX.Element[] = [];
    for (const radioItem of radioItems) {
        options.push(
            <Radio
                key={radioItem.label}
                label={radioItem.value}
                value={radioItem.label}
            />
        );
        if (radioItem.value === radioValue) {
            options.push(
                <TextArea
                    autoResize={true}
                    className="ml-4"
                    onChange={(e) => onChangeTextArea(e.target.value)}
                    value={textAreaValue ?? ''}
                    variant="outline"
                />
            );
        }
    }

    return options;
}

function getRadioGroupProps(properties: Omit<RadioGroupProps, 'children'>): Omit<RadioGroupProps, 'children'> {
    return {
        error: getValidationErrorTranslation(properties.error),
        layout: properties.layout,
        name: properties.name,
        onChange: (event) => {
            if (properties.onChange) {
                properties.onChange(event.target.value as any);
            }
        },
        value: properties.value,
    };
}
